/**
 * Per branch image gallery spec (figma): hero tiles render at 1.8:1
 * (== 9/5); every other image is a 1:1 thumbnail. `cover_image` and
 * `product_cover_image` (when present) are the hero entries; everything
 * inside `images[]` is a thumbnail. The owner of the data
 * (`branch-detail.vue`) merges the three fields into the gallery list
 * and tags each item via `isPrimary`.
 */
export const BRANCH_IMAGE_GALLERY = {
  HERO_ASPECT_RATIO: 9 / 5,
  REST_ASPECT_RATIO: 1,
} as const
